import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import { isProd } from '@/config';
import dayjs from 'dayjs';
export default {
  props: {
    userBehaviorCouponInfo: {
      type: Object,
      default: function _default() {}
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      couponPoster: 'https://p0.pipi.cn/mediaplus/fe_rock_web/0fa334b7845e3272a982bf9bd1785b5fc1e7b.png?imageMogr2/thumbnail/2500x2500%3E',
      isHide: false,
      isEntering: false,
      touchStartY: 0,
      isDragging: false
    };
  },
  computed: {
    endTime: function endTime() {
      var _dayjs, _this$userBehaviorCou;
      return (_dayjs = dayjs((_this$userBehaviorCou = this.userBehaviorCouponInfo) === null || _this$userBehaviorCou === void 0 ? void 0 : _this$userBehaviorCou.endTime)) === null || _dayjs === void 0 ? void 0 : _dayjs.format('YYYY.MM.DD HH:mm:ss');
    },
    price: function price() {
      var _this$userBehaviorCou2;
      return ((_this$userBehaviorCou2 = this.userBehaviorCouponInfo) === null || _this$userBehaviorCou2 === void 0 ? void 0 : _this$userBehaviorCou2.value) / 100;
    },
    posterUrl: function posterUrl() {
      var _this$userBehaviorCou3;
      return ((_this$userBehaviorCou3 = this.userBehaviorCouponInfo) === null || _this$userBehaviorCou3 === void 0 ? void 0 : _this$userBehaviorCou3.notificationStyleUrl) || this.couponPoster;
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.isEntering = true;
    this.autoCloseTimer = setTimeout(function () {
      _this.hideModal();
    }, 3500);
  },
  beforeDestroy: function beforeDestroy() {
    this.clearAllTimers();
  },
  methods: {
    hideModal: function hideModal() {
      var _this2 = this;
      try {
        if (this.isHide) return; // 防止重复触发
        this.clearAllTimers();
        this.isHide = true;
        this.hideModalTimer = setTimeout(function () {
          _this2.$emit('closeModal');
          _this2.isHide = false;
          _this2.isDragging = false;
        }, 500);
      } catch (error) {
        this.$owlReportError('用户行为策略-优惠券关闭异常', error);
      }
    },
    handleUseCoupon: function handleUseCoupon() {
      this.hideModal(); // 手动触发关闭动画
      var _ref = this.userBehaviorCouponInfo || {},
        source = _ref.source,
        batchId = _ref.batchId,
        couponCode = _ref.couponCode;
      if ((couponCode || couponCode === 0) && (source || source === 0) && (batchId || batchId === 0) && this.isLogin) {
        var _Drip$constant, _Drip$constant2;
        var lng = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.lng) || '';
        var lat = (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant2 = Drip.constant) === null || _Drip$constant2 === void 0 ? void 0 : _Drip$constant2.lat) || '';
        Drip.redirect(isProd ? "https://m.maoyan.com/mtrade/coupon/detail-new?lat=".concat(lat, "&lng=").concat(lng, "&code=").concat(couponCode, "&source=").concat(source, "&batchId=").concat(batchId) : "https://canary.movie.test.maoyan.com/mtrade/coupon/detail-new?lat=".concat(lat, "&lng=").concat(lng, "&code=").concat(couponCode, "&source=").concat(source, "&batchId=").concat(batchId));
      }
    },
    clearAllTimers: function clearAllTimers() {
      clearTimeout(this.autoCloseTimer); // 清除自动关闭定时器
      clearTimeout(this.hideModalTimer); // 清除动画定时器
      this.autoCloseTimer = null;
      this.hideModalTimer = null;
    },
    handleTouchStart: function handleTouchStart(e) {
      var _e$touches, _e$touches$;
      if (this.isHide) return; // 正在隐藏时忽略触摸
      this.touchStartY = e === null || e === void 0 ? void 0 : (_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : (_e$touches$ = _e$touches[0]) === null || _e$touches$ === void 0 ? void 0 : _e$touches$.clientY;
      this.isDragging = true;
    },
    handleTouchMove: function handleTouchMove(e) {
      if (this.isHide) return; // 正在隐藏时忽略触摸
      if (!this.isDragging) return;
      e.preventDefault(); // 阻止页面滚动
    },

    handleTouchEnd: function handleTouchEnd(e) {
      var _e$changedTouches, _e$changedTouches$;
      if (this.isHide) return; // 正在隐藏时忽略触摸
      if (!this.isDragging) return;
      this.isDragging = false;
      var touchY = e === null || e === void 0 ? void 0 : (_e$changedTouches = e.changedTouches) === null || _e$changedTouches === void 0 ? void 0 : (_e$changedTouches$ = _e$changedTouches[0]) === null || _e$changedTouches$ === void 0 ? void 0 : _e$changedTouches$.clientY;
      if ((touchY || touchY === 0) && (this.touchStartY || this.touchStartY === 0)) {
        var deltaY = touchY - this.touchStartY;
        if (deltaY < -10) {
          this.hideModal();
        }
      }
    }
  }
};